import styled from "styled-components";

export const GlobalProjectDrawerCountersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;

  & > :not(:last-child) {
    margin-right: 20px;
  }
`;

export const GlobalProjectDrawerCounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;

  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const GlobalProjectDrawerCounterIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const GlobalProjectDrawerCounter = styled.span`
  font-weight: 300;
  font-size: 38px;
  line-height: 42px;
  text-align: center;
  color: #171C33;
`

export const GlobalProjectDrawerCounterText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(23, 28, 51, 0.5);
`;

export const GlobalProjectDrawerHighlightText = styled.h4`
  font-weight: 300;
  font-size: 24px;
  line-height: 31px;

  & > .people {
    color: #FFC229;
  }

  & > .company {
    color: #5478A1;
  }

  & > .skill {
    color: #EB823D;
  }

  & > .client {
    color: #104D5B;
  }
`;

export const GlobalProjectDrawerHighlightsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  & > :not(:last-child) {
    margin-right: 64px;
  }
`;

export const GlobalProjectDrawerHighlightContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const GlobalProjectDrawerHighlightTitle = styled.h5`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(23, 28, 51, 0.5);
`;

export const GlobalProjectDrawerHighlightTextContainer = styled.div`
  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const GlobalProjectDrawerDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;

  & > :not(:last-child) {
    margin-right: 32px;
  }
`;

export const GlobalProjectDrawerDetail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const GlobalProjectDrawerParagraph = styled.p`
  font-weight: 300;
  font-size: 14px;
  color: #171C33;
`

export const GlobalProjectDrawerDetailText = styled(GlobalProjectDrawerParagraph)`
  line-height: 18px;
`;

export const GlobalProjectDrawerCompanyLogo = styled.img`
  width: 64px;
  height: 64px;
  background: #FFFFFF;
  border: 2px solid #5478A1;
  border-radius: 1000px;
`;